import {
  AfterViewInit,
  Component,
  ContentChild,
  ContentChildren,
  ElementRef,
  Input,
  OnInit,
  QueryList,
  ViewChildren,
} from "@angular/core";
import { TextPopUpConfig } from "../../interfaces/text-pop-up-config";

@Component({
  selector: "app-text-pop-up",
  templateUrl: "./text-pop-up.component.html",
  styleUrls: ["./text-pop-up.component.scss"],
})
export class TextPopUpComponent implements AfterViewInit, OnInit {
  @Input()
  config: TextPopUpConfig;

  @ViewChildren("header")
  header: QueryList<ElementRef>;

  @ViewChildren("dragDiv")
  dragDiv: QueryList<ElementRef>;

  show = false;

  align: "left" | "right";

  constructor() {}

  ngOnInit() {
    this.align = this.config?.align ? this.config.align : "left";
  }

  ngAfterViewInit() {
    this.dragDiv.changes.subscribe((qList) => {
      if (qList.length > 0) {
        this.dragElement();
      }
    });
  }

  togglePopUp() {
    this.show = !this.show;

    if (this.show) {
      if (this.config?.openPopupCallback != null) {
        this.config.openPopupCallback();
      }
    } else if (this.config?.closePopupCallback != null) {
      this.config.closePopupCallback();
    }

    // right align is tricky with hidden components.
    // might come up with a better solution later
    if (this.align == "right" && this.show) {
      setTimeout(() => {
        const elmnt = this.dragDiv.first.nativeElement;
        elmnt.style.right = "0";
      });
    }
  }

  dragElement() {
    const elmnt = this.dragDiv.first.nativeElement;
    const headerElem = this.header.first.nativeElement;
    let pos1 = 0,
      pos2 = 0,
      pos3 = 0,
      pos4 = 0;
    if (headerElem) {
      // if present, the header is where you move the DIV from:
      headerElem.onmousedown = dragMouseDown;
    } else {
      // otherwise, move the DIV from anywhere inside the DIV:
      elmnt.onmousedown = dragMouseDown;
    }

    const originalDocumentOnMouseUp: any = document.onmouseup;
    const originalDocumentOnMouseMove: any = document.onmousemove;

    function dragMouseDown(e) {
      e = e || window.event;
      e.preventDefault();
      // get the mouse cursor position at startup:
      pos3 = e.clientX;
      pos4 = e.clientY;

      document.onmouseup = endDragElement;
      // call a function whenever the cursor moves:
      document.onmousemove = elementDrag;
    }

    function elementDrag(e) {
      if (originalDocumentOnMouseMove !== null) {
        originalDocumentOnMouseMove(e);
      }

      e = e || window.event;
      e.preventDefault();
      // calculate the new cursor position:
      pos1 = pos3 - e.clientX;
      pos2 = pos4 - e.clientY;
      pos3 = e.clientX;
      pos4 = e.clientY;
      // set the element's new position:
      elmnt.style.top = elmnt.offsetTop - pos2 - 1 + "px"; // subtract one because of 1px margin
      elmnt.style.left = elmnt.offsetLeft - pos1 + "px";
      elmnt.style.removeProperty("right");
    }

    function endDragElement(e) {
      if (originalDocumentOnMouseUp !== null) {
        originalDocumentOnMouseUp(e);
      }

      // stop moving when mouse button is released:
      document.onmouseup = originalDocumentOnMouseUp;
      document.onmousemove = originalDocumentOnMouseMove;
    }
  }
}
